import { inject, Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'
import { PermissionsService } from '@client/Services/PermissionsService'
import User from '@client/User'

@Injectable()
export class LoggedOutGuard implements CanActivate {
	public user: User

	public router: Router

	constructor() {
		const permissionService: PermissionsService = inject(PermissionsService)
		this.router = inject(Router)

		this.user = permissionService.user
	}

	public canActivate(): boolean {
		if (this.user) {
			this.router.navigate(['/my-account'])

			return false
		}

		return true
	}
}
